export enum LogLevelEnum {
  error = 0,
  warning = 1,
  info = 2,
  debug = 3,
}

export enum LogProviderEnum {
  sentry = 'sentry',
  segment = 'segment',
  console = 'console',
}

export interface ILogsManager {
  logError(error: Error | string, data?: any): void;
  logWarning(message: string, data?: any): void;
  logInfo(message: string, data?: any): void;
  logDebug(message: string, data?: any): void;
}
